import React from 'react';

import { DropIndicator as Border } from '@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/border';
import { DropIndicator as Line } from '@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/box';

import type { Instruction } from './types';

export function DropIndicator({ instruction }: { instruction: Instruction }) {
	const appearance = instruction.blocked ? 'warning' : 'default';

	if (instruction.operation === 'combine') {
		return <Border appearance={appearance} />;
	}

	if (instruction.operation === 'reorder-before') {
		return <Line edge="top" appearance={appearance} />;
	}
	if (instruction.operation === 'reorder-after') {
		return <Line edge="bottom" appearance={appearance} />;
	}
	return null;
}
